import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { roleGuard } from './guards/role.guard';

export const appRoutes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: 'register',
    loadComponent: () => import('./pages/mock-register/mock-register.component').then(m => m.MockRegisterComponent),
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./pages/mock-forgot-password/mock-forgot-password.component').then(m => m.MockForgotPasswordComponent),
  },

  {
    path: '',
    redirectTo: '/projects',
    pathMatch: 'full',
  },
  {
    path: 'projects',
    loadChildren: () => import('./pages/projects/projects.routes').then(m => m.PROJECTS_ROUTES),
    data: { preload: true },
    canActivate: [authGuard, roleGuard],
  },

  {
    path: 'employees',
    loadChildren: () => import('./pages/employees/employees.routes').then(m => m.EMPLOYEES_ROUTES),
    data: { preload: true },
    canActivate: [authGuard, roleGuard],
  },
  {
    path: 'clients',
    loadComponent: () => import('./pages/clients/clients.component').then(m => m.ClientsComponent),
    canActivate: [authGuard, roleGuard],
  },
  {
    path: 'work-items',
    loadComponent: () =>
      import('./pages/work-items-definition/work-items-definition.component').then(m => m.WorkItemsComponent),
    canActivate: [authGuard, roleGuard],
  },
  {
    path: 'workflows',
    loadChildren: () => import('./pages/workflows/workflows.routes').then(m => m.WORKFLOWS_ROUTES),
    data: { preload: true },
    canActivate: [authGuard, roleGuard],
  },
  {
    path: 'workflow-instances/:documentId',
    loadComponent: () =>
      import('./pages/workflows/workflow-instance-detail/workflow-instance-detail.component').then(
        m => m.WorkflowInstanceDetailComponent,
      ),
    canActivate: [authGuard, roleGuard],
  },
  {
    path: 'settings',
    loadComponent: () => import('./pages/mock-settings/mock-settings.component').then(m => m.MockSettingsComponent),
    canActivate: [authGuard, roleGuard],
  },
  {
    path: 'otp-2fa',
    loadComponent: () => import('./pages/mock-otp-2fa/mock-otp-2fa.component').then(m => m.MockOtp2faComponent),
    canActivate: [authGuard, roleGuard],
  },
  {
    path: 'forbidden',
    loadComponent: () => import('./pages/io-error-403/io-error-403.component').then(m => m.IoError403Component),
    canActivate: [authGuard],
  },
  {
    path: '**',
    loadComponent: () => import('./pages/io-error-404/io-error-404.component').then(m => m.IoError404Component),
  },
];
